var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-collapse',{staticClass:"collapses",attrs:{"accordion":"","bordered":false}},_vm._l((_vm.guides),function(guide,index){return _c('a-collapse-panel',{key:index+1,staticClass:"topicGuide",attrs:{"header":guide.topic}},[_c('p',{staticClass:"descGuide",style:(_vm.customStyle),domProps:{"innerHTML":_vm._s(guide.description)}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }